export type ButtonColor = 'accent' | 'danger' | 'success' | 'info' | 'neutral';
export type ButtonVariant = 'filled' | 'outlined' | 'inverted' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export const colors: Record<ButtonColor, Record<ButtonVariant, string>> = {
	accent: {
		filled: 'bg-accent hover:bg-accent-400 text-white',
		ghost: 'text-accent hover:text-accent-400 enabled:active:text-accent-600',
		outlined: 'border text-accent hover:text-accent-400 enabled:active:text-accent-600',
		inverted: 'bg-white text-accent hover:text-accent-400 ',
	},
	info: {
		filled: 'bg-info hover:bg-info-400 text-white',
		ghost: 'text-info hover:text-info-400 enabled:active:text-info-700',
		outlined: 'border text-info hover:text-info-400 enabled:active:text-info-600',
		inverted: 'bg-white text-info hover:text-info-400',
	},
	danger: {
		filled: 'bg-danger hover:bg-danger-600 text-white',
		ghost: 'text-danger hover:text-danger-600 enabled:active:text-danger-500',
		outlined: 'border text-danger hover:text-danger-600 enabled:active:text-danger-500',
		inverted: 'bg-white text-danger hover:text-danger-600',
	},
	success: {
		filled: 'bg-success hover:bg-success-600 text-white',
		ghost: 'text-success hover:text-success-600 enabled:active:text-success-500',
		outlined: 'border text-success hover:text-success-600 enabled:active:text-success-500',
		inverted: 'bg-white text-success hover:text-success-600',
	},
	neutral: {
		filled: 'bg-neutral-900 hover:bg-neutral-800 text-white',
		ghost: 'text-neutral-900 hover:text-neutral-800 enabled:active:text-neutral-900',
		outlined:
			'border text-neutral-900 hover:text-neutral-800 enabled:active:text-neutral-900',
		inverted: 'bg-white text-neutral-900 hover:text-neutral-800',
	},
};

export const sizes = {
	lg: {
		normal: {
			classes: 'px-8 h-12 text-body-lg',
			iconSize: 1.5,
		},
		iconOnly: {
			classes: 'h-12 w-12',
			iconSize: 2,
		},
		icon: {
			left: '-ml-2 mr-2',
			right: '-mr-2 ml-2',
		},
	},
	md: {
		normal: {
			classes: 'px-6 h-10 text-body-lg',
			iconSize: 1.5,
		},
		iconOnly: {
			classes: 'h-10 w-10',
			iconSize: 1.5,
		},
		icon: {
			left: '-ml-1 mr-2',
			right: '-mr-1 ml-2',
		},
	},
	sm: {
		normal: {
			classes: 'px-5 h-8 text-body-base',
			iconSize: 1.25,
		},
		iconOnly: {
			classes: 'h-8 w-8',
			iconSize: 1.25,
		},
		icon: {
			left: '-ml-1 mr-2',
			right: '-mr-1 ml-2',
		},
	},
};

export const widthClassMap = {
	sm: 'sm:w-auto',
	md: 'md:w-auto',
	lg: 'lg:w-auto',
	xl: 'xl:w-auto',
};
